import { render } from "./CursorFigma.vue?vue&type=template&id=620ad41a&scoped=true"
import script from "./CursorFigma.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorFigma.vue?vue&type=script&setup=true&lang=js"

import "./CursorFigma.vue?vue&type=style&index=0&id=620ad41a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620ad41a"],['__file',"src/scripts/common/sideBars/design/cursors/CursorFigma.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "620ad41a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('620ad41a', __exports__)) {
    api.reload('620ad41a', __exports__)
  }
  
  module.hot.accept("./CursorFigma.vue?vue&type=template&id=620ad41a&scoped=true", () => {
    api.rerender('620ad41a', render)
  })

}


export default __exports__